import {Component, OnInit} from '@angular/core';
import {DocumentoComponent} from './documento/documento.component';
import {Documento} from '../shared/model/documentos.model';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {ModalLogComponent} from '../shared/components/modal-log/modal-log.component';
import {LogDocumento} from '../shared/model/logDocumento.model';
import {Usuario} from '../shared/model/usuario.model';
import {DocumentoService} from '../shared/service/documento.service';
import {Page} from '../shared/model/page.model';
import {LogDocumentoService} from '../shared/service/log-documento.service';

@Component({
  selector: 'app-home',
  imports: [
    DocumentoComponent

  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit{
   documento: Documento[] = [];
   logs: LogDocumento[] = [];
   usuario: Usuario = new Usuario();

   constructor(
     private router: Router,
     private dialog: MatDialog,
     private informacoesService: DocumentoService,
     private logDocumentoService: LogDocumentoService,
   ) {}

  ngOnInit(){
    this.usuario = this.recuperaDadosUsuario() ?? new Usuario();
    this.buscarDocumentos(this.usuario.parceiroId, this.usuario.coligadaId);
    this.buscarLogDocumentoPorIdPareceiro(this.usuario.parceiroId, this.usuario.coligadaId);
  }

   redirecionarPerfil(){
     this.router.navigate(['/perfil']);
   }

   redirecionarMeusDocumentos(){
     this.router.navigate(['/meus-documentos']);
   }

   recuperaDadosUsuario(){
    const parceiroLogado = localStorage.getItem('parceiro');
     return parceiroLogado ? JSON.parse(parceiroLogado) as Usuario: null;
   }

  buscarDocumentos(idParceiro: number | undefined, idColigada: number | undefined) {
     this.informacoesService.buscarDocumentos(idParceiro, idColigada).subscribe({
       next: (response: Page<Documento>) => {
         this.documento = response?.content || [];
       },
       error: (error: any) => {
         console.error('Erro ao buscar informações documento:', error);
         this.documento = [];
       }
     });
   }

   buscarLogDocumentoPorIdPareceiro(idParceiro: number | undefined, idColigada: number | undefined){
     this.logDocumentoService.buscarLogDocumentoPorParceiro(idParceiro, idColigada).subscribe({
       next: (response: LogDocumento[]) => {
         this.logs = response || [];
       },
       error: (error: any) => {
         console.error('Erro ao buscar logs documento:', error);
         this.logs = [];
       }
     }
     )
   }

   abrirModalLog(){
     const dialogRef = this.dialog.open(ModalLogComponent, {
       width: '500px',
       position: { right: '0', top: '0' },
       panelClass: 'logs-dialog',
       data: { logs: this.logs },
       hasBackdrop: true,
       disableClose: false
     });
   }
}
